import React from 'react';
import PropTypes from 'prop-types';
import { TileButton } from './TileButton';

const TRY_AGAIN = 'Try again';

const TryAgainButton = ({
  onClick,
  value
}) => {
  return (
    <div className="sui-flex sui-shrink-0 sui-grow">
      <TileButton
        label={TRY_AGAIN}
        onClick={() => onClick(value)}
        value={value}
        data-testid="try-again-question"
      />
    </div>
  );
};

TryAgainButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export { TryAgainButton };
